import { sitesApi } from '../../services/sitesApi';
import { resolveEdgePlacementDisplay } from '../../utils/locationDisplay';

/** Build device PUT payload without legacy location / area_id form fields. */
export function buildDeviceUpdatePayload(
  form: {
    device_id: string;
    name: string;
    description: string;
    device_type: string;
    location: string;
    area_id: string;
    group_id: string;
    capabilities: unknown;
    device_metadata: unknown;
  },
  orgId: string,
  siteId: string,
): Record<string, unknown> {
  const { area_id: _areaId, location: _location, ...deviceFields } = form;
  const payload: Record<string, unknown> = { ...deviceFields };
  if (orgId && siteId) {
    payload.org_id = orgId;
    payload.site_id = siteId;
  }
  return payload;
}

export function edgeLabelFromForm(location: string): string | null {
  return resolveEdgePlacementDisplay({ location }) || null;
}

export async function saveDevicePlacement(opts: {
  canWriteSites: boolean;
  siteId: string;
  deviceId: string;
  areaId: string;
  location: string;
}): Promise<void> {
  const placementSite = String(opts.siteId || '').trim();
  if (!opts.canWriteSites || !placementSite) return;
  await sitesApi.putDevicePlacement(placementSite, opts.deviceId, {
    area_id: String(opts.areaId || '').trim() || null,
    placement_label: edgeLabelFromForm(opts.location),
  });
}
